import { render, staticRenderFns } from "./ModalCadastraAtividadeDisciplinaCompetencia.vue?vue&type=template&id=e39eb280"
import script from "./ModalCadastraAtividadeDisciplinaCompetencia.vue?vue&type=script&lang=js"
export * from "./ModalCadastraAtividadeDisciplinaCompetencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports